import React from 'react';
import TabContainer from '../../components/TabContainer';
import FiyatGirisiPage from '../finance/FiyatGirisiPage';
import GiderGirisiPage from '../finance/GiderGirisiPage';
import GeciciVergiPage from '../finance/GeciciVergiPage';
import StopajRaporuPage from '../finance/StopajRaporuPage';
import OdemePlaniPage from '../finance/OdemePlaniPage';
import CariHesaplarPage from '../finance/CariHesaplarPage';
import SirketlerArasiSatislarPage from '../finance/SirketlerArasiSatislarPage';
import OdemeTakibiPage from '../finance/OdemeTakibiPage';
import KrediKartlariPage from '../finance/KrediKartlariPage';
import MuhasebeFisleriPage from '../finance/MuhasebeFisleriPage';
import KasaDefterPage from '../finance/KasaDefterPage';
import BirimDonusumPage from '../stok/BirimDonusumPage';

const FinansPage = () => {
  const tabs = [
    { id: 'cari-hesaplar', label: 'Cari Hesaplar', icon: '🏦', component: <CariHesaplarPage /> },
    { id: 'fatura-girisi', label: 'Fatura Girişi', icon: '🧾', component: <FiyatGirisiPage /> },
    { id: 'gider-girisi', label: 'Gider Girişi', icon: '📝', component: <GiderGirisiPage /> },
    { id: 'gecici-vergi', label: 'Geçici Vergi', icon: '🧾', component: <GeciciVergiPage /> },
    { id: 'stopaj-raporu', label: 'Stopaj Raporu', icon: '🧾', component: <StopajRaporuPage /> },
    { id: 'kasa-defter', label: 'Kasa Defteri', icon: '📒', component: <KasaDefterPage /> },
    { id: 'odeme-takibi', label: 'Ödeme Takibi', icon: '💰', component: <OdemeTakibiPage /> },
    { id: 'kredi-kartlari', label: 'Kredi Kartları', icon: '💳', component: <KrediKartlariPage /> },
    { id: 'odeme-plani', label: 'Ödeme Planı', icon: '💳', component: <OdemePlaniPage /> },
    { id: 'sirketler-arasi', label: 'Şirketler Arası Satışlar', icon: '🔄', component: <SirketlerArasiSatislarPage /> },
    { id: 'muhasebe-fisleri', label: 'Muhasebe Fişleri', icon: '📒', component: <MuhasebeFisleriPage /> },
    { id: 'birim-donusum', label: 'Birim Dönüşümleri', icon: '🔄', component: <BirimDonusumPage /> },
  ];
  return <TabContainer title="Muhasebe" tabs={tabs} defaultTab="cari-hesaplar" />;
};

export default FinansPage;
